import React from "react";
import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-json5";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/mode-python";
import "ace-builds/src-noconflict/mode-golang";
import "ace-builds/src-noconflict/mode-sql";
import "ace-builds/src-noconflict/mode-dockerfile";
import "ace-builds/src-noconflict/mode-markdown";
import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/mode-yaml";
import "ace-builds/src-noconflict/theme-textmate";
import "ace-builds/src-noconflict/ext-searchbox";
import UnityTypography from "@bit/smartworks.unity-react.unity-typography-react";
import './UnityCodeEditor.css';
class UnityCodeEditor extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            error: ""
        };
        this.componentDidMount = () => {
            this.handleChange(this.props.value);
        };
        this.handleChange = (newValue) => {
            const { validation, onChange } = this.props;
            let error = '';
            if (validation instanceof Function) {
                error = validation(newValue);
            }
            this.setState({ error });
            onChange(newValue, error);
        };
    }
    getValidationMessage(message) {
        const { embedded } = this.props;
        return (React.createElement("div", { className: `code-editor-error ${embedded ? 'embedded' : ''}` },
            React.createElement(UnityTypography, { color: "medium", style: { "--font-color-medium": "var(--internal-validation-color)" }, size: "paragraph" }, message)));
    }
    shouldComponentUpdate(nextProps, nextState) {
        const { value: nextValue } = nextProps;
        const { error: nextError } = nextState;
        const { value } = this.props;
        const { error } = this.state;
        if (nextError !== error && nextValue === value)
            return false;
        return true;
    }
    render() {
        const { value, mode, label, dirty, minLines, maxLines, error: errorText = '', readOnly = false, highlightActiveLine = true, showLineNumbers = true, tabSize = 2, embedded = false } = this.props;
        const { error = '' } = this.state;
        const editorWrapperClass = (!(errorText || error) && !embedded) ? "editor-wrapper padded" : "editor-wrapper";
        const dirtyGutterClass = embedded ? "dirty-gutter embedded" : "dirty-gutter";
        const editorContainerClass = embedded ? "editor-container embedded" : "editor-container";
        const editorStyle = { width: '100%' };
        const lineProps = {};
        if (minLines)
            lineProps.minLines = minLines;
        if (maxLines)
            lineProps.maxLines = maxLines;
        if (!minLines && !maxLines)
            editorStyle.flex = 1;
        return (React.createElement("div", { className: editorWrapperClass },
            label && !embedded &&
                React.createElement("div", { className: "code-editor-label" },
                    React.createElement(UnityTypography, { color: "medium", size: "paragraph" }, label)),
            !!dirty && React.createElement("div", { className: dirtyGutterClass }),
            React.createElement("div", { className: editorContainerClass },
                React.createElement(AceEditor, Object.assign({ value: value, style: editorStyle, theme: "textmate", mode: mode === 'json' ? 'json5' : mode, editorProps: { $blockScrolling: true }, onChange: this.handleChange, readOnly: readOnly, highlightActiveLine: highlightActiveLine, setOptions: {
                        showLineNumbers
                    }, tabSize: tabSize, wrapEnabled: true }, lineProps))),
            (errorText || error) &&
                this.getValidationMessage(errorText || error)));
    }
}
export default UnityCodeEditor;
